import { render, staticRenderFns } from "./DonutComponent.vue?vue&type=template&id=ad4b3d98&"
import script from "./DonutComponent.vue?vue&type=script&lang=js&"
export * from "./DonutComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports